"use client";

import { FunnelIcon } from "@heroicons/react/24/outline";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Button,
  cn,
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@ubud-ui/react-ui-kit";
import { useState } from "react";
import { EducationLevelFilter } from "./education-level-filter";
import { GenderFilter } from "./gender-filter";
import { MaritalFilter } from "./marital-filter";

function FilterContainer({ path }: { path: string }) {
  return (
    <Accordion type="multiple" defaultValue={["education-level-filter"]}>
      <AccordionItem key="education-level-filter" value="education-level-filter">
        <AccordionTrigger className="leading-[140%]">Pendidikan</AccordionTrigger>
        <AccordionContent>
          <EducationLevelFilter path={path} />
        </AccordionContent>
      </AccordionItem>
      <AccordionItem key="marital-filter" value="marital-filter">
        <AccordionTrigger className="leading-[140%]">Status Pernikahan</AccordionTrigger>
        <AccordionContent>
          <MaritalFilter path={path} />
        </AccordionContent>
      </AccordionItem>
      <AccordionItem key="gender-filter" value="gender-filter">
        <AccordionTrigger className="leading-[140%]">Jenis Kelamin</AccordionTrigger>
        <AccordionContent>
          <GenderFilter path={path} />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}

export function MicroVacancyFilter({
  path = "/lowongan-dalam-negeri/lowongan-mikro",
  titleClassName,
}: {
  path?: string;
  titleClassName?: string;
}) {
  const [isSheetOpen, setIsSheetOpen] = useState<boolean>(false);
  const handleToggleSheet = (open: boolean) => {
    setIsSheetOpen(open);
  };

  return (
    <>
      <div className="hidden md:block">
        <h4 className={cn("text-xl sm:text-2xl font-bold mb-4", titleClassName)}>Filter</h4>
        <hr className="border-gray-200 my-0" />
        <FilterContainer path={path} />
      </div>
      <div className="md:hidden">
        <Sheet open={isSheetOpen} onOpenChange={handleToggleSheet}>
          <SheetTrigger asChild>
            <Button variant={isSheetOpen ? "default" : "outline"} className="rounded-full" size="sm">
              <span>Filter</span>
              <FunnelIcon className="size-5 min-w-5" />
            </Button>
          </SheetTrigger>
          <SheetContent className="overflow-y-auto p-4" closeClassName="top-4 right-4" closeIconClassName="w-7 h-7" side="right">
            <SheetHeader>
              <SheetTitle className="text-left">Filter</SheetTitle>
              <div className="mt-6 text-left">
                <FilterContainer path={path} />
              </div>
            </SheetHeader>
          </SheetContent>
        </Sheet>
      </div>
    </>
  );
}
